<template>
    <div id="SmartPolicing">
    <view1/>
    <view2/>
    <view3/>
    <view4/>
    <view5/>
    <view6/>
    <view7/>
    </div>

</template>
<script>
    export default {
        name: 'SmartPolicing',
        components: {
        view1: () => import('@/views/SmartPolicing/view1.vue'),
        view2: () => import('@/views/SmartPolicing/view2.vue'),
        view3: () => import('@/views/SmartPolicing/view3.vue'),
        view4: () => import('@/views/SmartPolicing/view4.vue'),
        view5: () => import('@/views/SmartPolicing/view5.vue'),
        view6: () => import('@/views/SmartPolicing/view6.vue'),
        view7: () => import('@/views/SmartPolicing/view7.vue')
        }
    }
</script>
<style scoped>
</style>